import {
  CURRENCY,
  FIAT,
  STABLECOIN,
  BANK_WITHDRAWAL_SUPPORTED_CURRENCIES,
  BANK_DEPOSIT_SUPPORTED_CURRENCIES,
} from '~/types'

export const fiatStablecoinConverter = {
  [CURRENCY.SGD]: CURRENCY.XSGD,
  [CURRENCY.XSGD]: CURRENCY.SGD,
  [CURRENCY.IDR]: CURRENCY.XIDR,
  [CURRENCY.XIDR]: CURRENCY.IDR,
  [CURRENCY.USD]: CURRENCY.XUSD,
  [CURRENCY.USDC]: CURRENCY.USD,
  [CURRENCY.USDT]: CURRENCY.USD,
  [CURRENCY.XUSD]: CURRENCY.USD,
}

export const fiatToStablecoinMap: Record<FIAT, STABLECOIN> = {
  [CURRENCY.SGD]: CURRENCY.XSGD,
  [CURRENCY.USD]: CURRENCY.XUSD,
}

/**
 * Checks whether a given currency is Fiat or not
 * @returns boolean
 */
export function isFiatCurrency(currency: CURRENCY): boolean {
  return [CURRENCY.SGD, CURRENCY.USD].includes(currency)
}

export function isStraitsxIssuedStablecoin(currency: CURRENCY): boolean {
  return [CURRENCY.XSGD, CURRENCY.XUSD].includes(currency)
}

export function isBankWithdrawalSupportedCurrency(currency: CURRENCY): boolean {
  return BANK_WITHDRAWAL_SUPPORTED_CURRENCIES.includes(currency)
}

export function isBankDepositSupportedCurrency(currency: CURRENCY): boolean {
  return BANK_DEPOSIT_SUPPORTED_CURRENCIES.includes(currency)
}
